export default {
      id: "diagram-1-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#diagram-1",
      toString: function () {
        return this.url;
      }
    }